import apiAction from 'common/redux/actions/apiAction';
import { POST_ADMIN_SHARED_WITH_FILTERS } from './apiPathConstants';
import { logError } from 'TAP/utils/commonMethods';

const getAdminSharedWithFilters = (data) => ({
  type: 'GET_ADMIN_SHARED_WITH_FILTERS',
  payload: data,
});

const getAdminSharedWithFiltersError = () => ({
  type: 'GET_ADMIN_SHARED_WITH_FILTERS_ERROR',
});

export const AdminSharedWithFiltersAction = (configParams) => {
  return apiAction.postAPI({
    url: POST_ADMIN_SHARED_WITH_FILTERS(),
    data: configParams,
    onSuccess: getAdminSharedWithFilters,
    onFailure: (err) => {
      logError('Error occurred while fetching shared recipients:', err);
      return getAdminSharedWithFiltersError();
    },

    label: 'FETCH_ADMIN_SHARED_WITH_FILTERS',
  });
};
